import React from 'react';
import { Procedure } from 'types/procedure';
import history from 'services/history';
import DataGridList from 'components/data-grid/DataGridList';
import { procedureTableTemplate } from '../../template/procedureTableTemplate';

type ProcedureListTableProps = {
  procedures: Procedure[];
};

const ProcedureListTable: React.FC<ProcedureListTableProps> = ({ procedures }) => {
  return (
    <DataGridList
      template={procedureTableTemplate}
      rows={procedures}
      getRowId={row => row.id}
      onRowClick={row => history.push(`/consultation/${row.id}`)}
      fileName="consultas"
      sheetName="Consultas"
    />
  );
};

export default ProcedureListTable;
